import Sources from './Sources';

export type { SourcesProps } from './Sources';

export default Sources;
